import { useGetLazyDocumentsQuery } from '@views/ProofDocuments/graphql';
import { useNavigate } from '@hooks/navigation';
import { getDocumentTypesData } from '../utils';

export const useController = ({
  type,
}) => {
  const cardData = getDocumentTypesData(type);
  const navigate = useNavigate();

  const [getDocuments, { loading: isLoading }] = useGetLazyDocumentsQuery({
    onCompleted: () => navigate('../../'),
    fetchPolicy: 'network-only',
  });

  const onConfirm = () => getDocuments();

  return {
    cardData,
    onConfirm,
    isLoading,
  };
};
